var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupervisedIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2954_26062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43359 4.57959L11.506 2.22363L19.5703 4.57959V9.41073C19.57 11.8866 18.7907 14.2997 17.3429 16.3081C15.8951 18.3165 13.8521 19.8186 11.5033 20.6015C9.15358 19.8189 7.10975 18.3167 5.6614 16.3078C4.21305 14.2989 3.43363 11.8851 3.43359 9.40849V4.57959Z",
    stroke: "white",
    strokeWidth: 0.896483,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46777 10.7402L10.6055 13.8779L15.9844 8.49902",
    stroke: "white",
    strokeWidth: 0.896483,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2954_26062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5156,
    height: 21.5156,
    fill: "white",
    transform: "translate(0.744141 0.430664)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisedIcon);
export default __webpack_public_path__ + "static/media/supervisedIcon.999847bd0a70a99866580c52dd9cf7ee.svg";
export { ForwardRef as ReactComponent };